<template>
  <!-- Fund at a glance starts here -->
  <section class="fund-at-a-glance-vue filter-view">
    <div class="row">
      <div class="col-lg-2 col-md-12">
        <span class="font-weight-bold"><slot name="hl-fundsummary-shareclassfilter"></slot></span>
        <div class="filtering-dropdown font-weight-bold">
          <div class="filtering-dropdown-container">
            <button @click="showfundInfoItemClass = !showfundInfoItemClass" class="filtering-dropdown-container-btn">{{selectedfundInfoItemClass}} <span class="icon-arrow-down"></span></button>
            <ul v-show="showfundInfoItemClass" class="filtering-dropdown-list list-unstyled">
              <li @click="selectedfundInfoItemClass = shareClass; showfundInfoItemClass = !showfundInfoItemClass;" v-for="shareClass in filteredfundInfoItemData" :value="shareClass" :key="shareClass" tabindex="0" aria-role="option" aria-live="polite" aria-label="" class="filtering-dropdown-list-item"> <span class="filtering-dropdown-list-item-text">{{shareClass}}</span></li>
            </ul>
          </div>
        </div>
      </div>
      <div :class="[hideInvestmentMin ? 'col-lg-3' : 'col-lg-2', 'col-6', 'fund-column', 'charcoal-text']"><span class="font-weight-bold"><slot name="hl-fundsummary-navheader"></slot></span> <span class="fund-as-of">{{navasofdatetext}}</span><br /><span class="fund-data">{{getNAV(selectedfundInfoItemClass)}} ({{getNavCurrencyName(selectedfundInfoItemClass)}})</span></div>
      <div v-if="!hideInvestmentMin" class="col-lg-2 col-6 fund-column charcoal-text"><span class="font-weight-bold"><slot name="hl-fundsummary-mininvestheader"></slot></span><br /><span class="fund-data">{{getInvestmentMin(selectedfundInfoItemClass)}} ({{getInvestmentMinCurrencyName(selectedfundInfoItemClass)}})</span></div>
      <div :class="[hideInvestmentMin ? 'col-lg-3' : 'col-lg-2']" class="col-6 fund-column charcoal-text"><span class="font-weight-bold"><slot name="hl-fundsummary-fundsizeheader"></slot></span><br /><span class="fund-data">{{getFundSize(selectedfundInfoItemClass)}} ({{getFundSizeCurrencyName(selectedfundInfoItemClass)}})</span></div>
      <div class="col-lg-4 col-6 fund-column no-bar">
        <div 
            v-if="selectedfundInfoItemClass"
            class="row fund-downloads"
        >
          <div
            v-for="doc in getDocuments(selectedfundInfoItemClass)"
            class="fund-doc col-md-6"
          >
            <a v-show="doc.downloadLink" class="fund-anchor" :href="doc.downloadLink" target="_blank">
              <i :class="'bg-blue p-1 pl-2 bi bi-' + (doc.forceDownloadLink ? 'download' : 'box-arrow-up-right')"></i>
              {{ doc.docName }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Fund at a glance ends here -->
</template>

<script>
export default {
props:
{
    griddatastring: String,
    hideinvmin: String
},
data() {
    return {
      selectedfundInfoItemClass: null,
      showfundInfoItemClass: false,
      filteredfundInfoItemData: []
    };
  },
  created() {
    var tempfundInfoItemClass = [];

    //Dynamically fill dropdown with unique values from data
    this.fundInfoItemData.forEach(function (d) {
      if (!tempfundInfoItemClass.includes(d.shareClass)) {
        tempfundInfoItemClass.push(d.shareClass);
      }
    });

    this.filteredfundInfoItemData = tempfundInfoItemClass;
  if(this.fundInfoItemData.length > 0)
    this.selectedfundInfoItemClass = this.fundInfoItemData[0].shareClass;
  },
  methods: {
    //methods
    decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    getNAV(selectedItem) {
      var localFieldData = "";

      if (selectedItem != null) {
        this.fundInfoItemData.forEach(function (d) {
          if (selectedItem.includes(d.shareClass)) {
            localFieldData = d.navUSD;
          }
        });

        return localFieldData;
      } else {
        return null;
      }
    },
    getNavCurrencyName(selectedItem) {
      var localFieldData = "";

      if (selectedItem != null) {
        this.fundInfoItemData.forEach(function (d) {
          if (selectedItem.includes(d.shareClass)) {
            localFieldData = d.navCurrency;
          }
        });

        return localFieldData;
      } else {
        return null;
      }
    },
    getNavDate(selectedItem) {
      var localFieldData = "";
      var dateFormat = "";
      
      if (selectedItem != null) {
        this.fundInfoItemData.forEach(function (d) {
          if (selectedItem.includes(d.shareClass)) {
            localFieldData = d.navDate;
          }
        });
        
        return localFieldData;
      } else {
        return null;
      }
    },
    getInvestmentMin(selectedItem) {
      var localFieldData = "";
      var currency = "";

      if (selectedItem != null) {
        this.fundInfoItemData.forEach(function (d) {
          if (selectedItem.includes(d.shareClass)) {
            localFieldData = d.investmentMin;
          }
        });

        return localFieldData;
      } else {
        return null;
      }
    },
    getInvestmentMinCurrencyName(selectedItem) {
      var localFieldData = "";

      if (selectedItem != null) {
        this.fundInfoItemData.forEach(function (d) {
          if (selectedItem.includes(d.shareClass)) {
            localFieldData = d.investmentMinCurrency;
          }
        });

        return localFieldData;
      } else {
        return null;
      }
    },
    getFundSize(selectedItem) {
      var localFieldData = "";

      if (selectedItem != null) {
        this.fundInfoItemData.forEach(function (d) {
          if (selectedItem.includes(d.shareClass)) {
            localFieldData = d.fundSize;
          }
        });

        return localFieldData;
      } else {
        return null;
      }
    },
    getFundSizeCurrencyName(selectedItem) {
      var localFieldData = "";

      if (selectedItem != null) {
        this.fundInfoItemData.forEach(function (d) {
          if (selectedItem.includes(d.shareClass)) {
            localFieldData = d.fundSizeCurrency;
          }
        });

        return localFieldData;
      } else {
        return null;
      }
    },
    getDocuments(selectedItem) {
      var localFieldData = [];
      if (selectedItem != null) {
        this.fundInfoItemData.forEach(function (d) {
          if (selectedItem.includes(d.shareClass)) {
             localFieldData = [...localFieldData, ...d.documents];
          }
        });
      }

      return localFieldData;
    }
  },
  computed: {
    //methods
    fundInfoItemData() 
    { 
      return JSON.parse(this.decodeHtml(this.griddatastring));
    },
    hideInvestmentMin()
    {
      return this.hideinvmin == "True" || this.hideinvmin == "true" || this.hideinvmin == "1";
    },
    navasofdatetext() {
        //Basically, String.Format(format, filterItemCount, totalRowsDocumentListData). Uses {0}, {1}, etc. If you need more parameters later, add them to 'args'
        var format = this.$slots['hl-fundsummary-navasofdateformat'][0].text.trim(); 
        var args = new Array(this.getNavDate(this.selectedfundInfoItemClass));
        return format.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined' ? args[number] : match;
        });
    },
  }
}
</script>

<style lang="scss">
section.fund-at-a-glance-vue
{
  padding: 30px 0px;

  &.filter-view
  {
    margin: 0;
  }

  .fund-icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
  
  .charcoal-text
  {
    color: #222529;
  }
  
  .fund-as-of
  {
    font-size: 14px;
  }

  .fund-data { 
    font-size: 24px;
  }
  
  .fund-doc { 
    margin-bottom: 15px;
  }

  .fund-anchor {
    cursor: pointer;
  }
  
  .filtering-dropdown {
    min-width: 150px;
    max-width: inherit;
    
    &:focus-within {
      outline: 0;
    }

    .filtering-dropdown-container
    {
      border: 1px solid #cccccc;

      .filtering-dropdown-list {
        min-width: 150px;
        max-width: inherit;
      }
    }
  }
}

@include respond-below(lg)
{
  section.fund-at-a-glance-vue
  {
    .filtering-dropdown {
      width: 50%;
      margin-bottom: 15px!important;
    }

    .fund-column {  
      padding-bottom: 10px;
    }

    #fundAtAGlanceApp .filtering-dropdown {
      padding-bottom: 10px;
    }
  }
}

@include respond-above(md)
{
  section.fund-at-a-glance-vue
  {
    padding-left: 30px;
    padding-right: 30px;

    .fund-column
    {  
      border-right: 1px solid darkgrey;
    }
    .fund-column.no-bar
    {
      border-right: 0px;
    }
  }
}

@include respond-above(lg)
{
  section.fund-at-a-glance-vue
  {
    .fund-downloads 
    {
      padding-left: 25px;
    }
  }
}
</style>